import React from 'react';

import AemComponent from '@/components/Aem/AemComponent/AemComponent';
import EditableText from '@/components/Aem/EditableText/EditableText';
import routePaths from '@/consts/route/routePaths';
import {twx} from '@/utils/tailwindUtils';

const AdvancedDiagnosticTitle = ({itemName, className}) => {
    return (
        <h1 className={twx('mt-4 text-28 ml:mb-4', className)}>
            <AemComponent component={EditableText} pageName={routePaths.ADVANCE_DIAGNOSTIC} itemName={itemName} />
        </h1>
    );
};

export default AdvancedDiagnosticTitle;
